import { type FC, useEffect } from 'react';

import { appendNotification } from 'state';

/**
 * Updates state to show notifications which are preloaded from Rails flash
 * messages when the page initially loads.
 */
const ShowInitialNotifications: FC = () => {
  useEffect(() => {
    if (window.ENV.flash.notice != null) {
      appendNotification({
        type: 'notice',
        content: window.ENV.flash.notice,
      });
    }

    if (window.ENV.flash.alert != null) {
      appendNotification({
        type: 'alert',
        content: window.ENV.flash.alert,
      });
    }
  }, []);

  return null;
};

export default ShowInitialNotifications;
